var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-loading" }, [
    _vm.isFail
      ? _c(
          "h4",
          { staticStyle: { border: "1px solid black", padding: "5px" } },
          [_vm._v("Erro ao carregar formulário...")]
        )
      : _c("h4", [_vm._v("Carregando...")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }